/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateGuarantor
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for update guarantor
 *
 */
const useUpdateGuarantor = (): UseMutationResult<unknown, IAxiosError, Guarantor.IPatchModel, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			await api.FHIRAccountApi.patchGuarantor(model);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.guarantorInfo] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateGuarantor;
